import { ref, computed, onUnmounted } from 'vue'

// Porto Alegre/RS - referência para cálculo do pôr do sol
const HEBCAL_URL = 'https://www.hebcal.com/shabbat?cfg=json&latitude=-30.0346&longitude=-51.2177&tzid=America/Sao_Paulo'

const shabbatStart = ref<Date | null>(null)
const shabbatEnd = ref<Date | null>(null)
const now = ref(new Date())

let fetched = false
let subscribers = 0
let tickInterval: ReturnType<typeof setInterval> | undefined
let refetchInterval: ReturnType<typeof setInterval> | undefined

interface HebcalItem {
  category: string
  date: string
}

async function fetchShabbatTimes() {
  try {
    const res = await fetch(HEBCAL_URL)
    if (!res.ok) throw new Error('Hebcal request failed')
    const data: { items?: HebcalItem[] } = await res.json()
    const candles = data.items?.find(item => item.category === 'candles')
    const havdalah = data.items?.find(item => item.category === 'havdalah')
    shabbatStart.value = candles ? new Date(candles.date) : null
    shabbatEnd.value = havdalah ? new Date(havdalah.date) : null
  } catch {
    // Falha segura: sem dados, o aviso simplesmente não aparece
    shabbatStart.value = null
    shabbatEnd.value = null
  }
}

export function useShabbat() {
  if (!fetched) {
    fetched = true
    fetchShabbatTimes()
  }

  subscribers++

  if (!tickInterval) {
    tickInterval = setInterval(() => {
      now.value = new Date()
    }, 60_000)
  }

  if (!refetchInterval) {
    refetchInterval = setInterval(fetchShabbatTimes, 6 * 60 * 60 * 1000)
  }

  onUnmounted(() => {
    subscribers--
    if (subscribers <= 0) {
      clearInterval(tickInterval)
      clearInterval(refetchInterval)
      tickInterval = undefined
      refetchInterval = undefined
    }
  })

  const isShabbatNow = computed(() => {
    if (!shabbatStart.value || !shabbatEnd.value) return false
    return now.value >= shabbatStart.value && now.value <= shabbatEnd.value
  })

  return { isShabbatNow }
}
